import { useState } from "react";

/**
 * Custom hook for managing all modal states in TeamDetails
 */
export const useTeamModals = () => {
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [showLeaveConfirm, setShowLeaveConfirm] = useState(false);
  const [isLeaving, setIsLeaving] = useState(false);
  const [showRejectConfirm, setShowRejectConfirm] = useState(false);
  const [rejectTarget, setRejectTarget] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showRemoveMemberConfirm, setShowRemoveMemberConfirm] = useState(false);
  const [removeMemberTarget, setRemoveMemberTarget] = useState(null);
  const [isRemovingMember, setIsRemovingMember] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [approveTarget, setApproveTarget] = useState(null);
  const [selectedMemberType, setSelectedMemberType] = useState(null);
  const [isChangingMemberType, setIsChangingMemberType] = useState(false);
  const [showSwapModal, setShowSwapModal] = useState(false);
  const [swapSource, setSwapSource] = useState(null);
  const [swapTargetUserId, setSwapTargetUserId] = useState("");

  return {
    showInviteModal,
    setShowInviteModal,
    showLeaveConfirm,
    setShowLeaveConfirm,
    isLeaving,
    setIsLeaving,
    showRejectConfirm,
    setShowRejectConfirm,
    rejectTarget,
    setRejectTarget,
    showDeleteConfirm,
    setShowDeleteConfirm,
    isDeleting,
    setIsDeleting,
    showRemoveMemberConfirm,
    setShowRemoveMemberConfirm,
    removeMemberTarget,
    setRemoveMemberTarget,
    isRemovingMember,
    setIsRemovingMember,
    showApproveModal,
    setShowApproveModal,
    approveTarget,
    setApproveTarget,
    selectedMemberType,
    setSelectedMemberType,
    isChangingMemberType,
    setIsChangingMemberType,
    showSwapModal,
    setShowSwapModal,
    swapSource,
    setSwapSource,
    swapTargetUserId,
    setSwapTargetUserId,
  };
};

export default useTeamModals;
